import { css, StyleDeclarationValue } from 'aphrodite';
import { FC, ReactNode } from 'react';
import { Button } from '../../../components-v2/Button';
import { Skeleton } from '../../../components-v2/Skeleton';
import { ChevronDown } from '../../svgs/icons/ChevronDown';
import { ChevronUp } from '../../svgs/icons/ChevronUp';
import { styleSheet } from './styles';

export const agentTileState = (
	caption: string,
	{ count, isError = false }: { count?: number; isError?: boolean } = {}
) => ({
	caption,
	count,
	isError,
});

export const AgentTile: FC<{
	caption: string;
	count?: number;
	icon: ReactNode;
	iconStyles: StyleDeclarationValue;
	isError?: boolean;
	isOpen: boolean;
	name: string;
	onToggle: () => void;
	panelId: string;
}> = ({ caption, count, icon, iconStyles, isError, isOpen, name, onToggle, panelId }) => (
	<Button
		variant='outline'
		styles={[styleSheet.tile, isOpen && styleSheet.tileOpen]}
		aria-expanded={isOpen}
		aria-controls={isOpen ? panelId : undefined}
		onClick={onToggle}
	>
		<span className={css(styleSheet.tileIcon, iconStyles)}>{icon}</span>
		<span className={css(styleSheet.tileText)}>
			<span className={css(styleSheet.tileHeadline, isError && styleSheet.tileError)}>
				{count != null ? <strong className={css(styleSheet.tileCount)}>{count}</strong> : null}
				{count != null ? ` ${caption}` : caption}
			</span>
			<span className={css(styleSheet.tileName)}>{name}</span>
		</span>
		{isOpen ? (
			<ChevronUp className={css(styleSheet.tileChevron)} />
		) : (
			<ChevronDown className={css(styleSheet.tileChevron)} />
		)}
	</Button>
);

export const AgentTileSkeleton: FC = () => (
	<div className={css(styleSheet.tileSkeleton)}>
		<Skeleton styles={[styleSheet.skeletonIcon]} />
		<Skeleton styles={[styleSheet.skeletonText]} />
	</div>
);
